import { useQueryClient } from '@tanstack/react-query';

import { findListedCommunityPost } from '../api/queryOptions';

import { useUserScope } from '@/hooks/useUserScope';

/**
 * The post as a cached list page already holds it, read only while `enabled`.
 * The post screen shapes its loading state from it; see `findListedCommunityPost`.
 */
export function useListedLibraryPost(postId: number, { enabled }: { enabled: boolean }) {
  const queryClient = useQueryClient();

  const { userId } = useUserScope();

  return enabled ? findListedCommunityPost(queryClient, userId, postId) : undefined;
}
